import { Breadcrumb } from "@gull";
import { AppContext } from "app/appContext";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import {
  exportMerchant,
  getMerchant,
  resetPassword,
  StatusUpdateHandler,
} from "app/services/memberService";
import queryString from "app/services/queryStringService";
import { default as config, default as enableEmulate } from "config.json";
import moment from "moment";
import Tooltip from "rc-tooltip";
import { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  ListGroup,
  Modal,
  Row,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Helmet } from "react-helmet";
import {
  AiFillFileExcel,
  AiOutlineCopy,
  AiOutlineSetting,
} from "react-icons/ai";
import {
  MdAccountBalanceWallet,
  MdAddBox,
  MdEdit,
  MdRefresh,
  MdSearch,
  MdVpnKey,
} from "react-icons/md";
import { NotificationManager } from "react-notifications";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const { frontUrl } = config;
const GroupTagging = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [affiliateId, setAffiliateId] = useState("");

  const [company, setCompany] = useState("");
  const [firstName, setFirstName] = useState("");
  const [railId, setRailId] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [group, setGroup] = useState("");
  const [DistributorId, setDistributorId] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);

  const [isShowGlobalFilter, setIsShowGlobalFilter] = useState(true);

  const [searchTrigger, setSearchTrigger] = useState(true);

  const balanceFormatter = (cell, row) => {
    return <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>;
  };
  const creditBalanceFormatter = (cell, row) => {
    return <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>;
  };
  const ledgerBalanceFormatter = (cell, row) => {
    return (
      <span className="text-center">
        ₹ {parseFloat(row.balance - row.creditLimit).toFixed(2)}
      </span>
    );
  };

  const securityFormatter = (cell, row) => {
    return (
      <>
        {row.securityBalance ? (
          <span className="text-center">
            ₹ {parseFloat(row.securityBalance).toFixed(2)}
          </span>
        ) : (
          <span className="text-center">₹ 0.00</span>
        )}
      </>
    );
  };

  const virtualbankHandler = (row) => {
    setSelectedMember(row);
  };
  const serviceMappingHandler = (row) => {
    setSelectedMember(row);
  };
  const updateUserName = (row) => {
    setSelectedMember(row);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "search":
        setSearch(value);
        break;
      case "affiliateId":
        setAffiliateId(value);
        break;

      case "company":
        setCompany(value);
        break;

      case "firstName":
        setFirstName(value);
        break;

      case "lastName":
        setLastName(value);
        break;

      case "emailId":
        setEmailId(value);
        break;

      case "status":
        setStatus(value);
        break;

      case "city":
        setCity(value);
        break;

      case "state":
        setState(value);
        break;

      case "country":
        setCountry(value);
        break;

      case "railId":
        setRailId(value);
        break;

      case "DistributorId":
        setDistributorId(value);
        break;
      default:
        break;
    }
  };

  const handleGlobalFilterChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "search":
        setSearch(value);
        break;

      // Add cases for other fields...
      default:
        break;
    }
  };

  const resetTableHandler = async () => {
    const query1 = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    const response = await getMerchant(query1);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);

      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const refreshFilter = async (e) => {
    setTimeout(() => {
      setSearch("");
      setAffiliateId("");

      setCompany("");
      setFirstName("");
      setLastName("");
      setEmailId("");
      setStatus("");
      setCity("");
      setState("");
      setCountry("");
      setRailId("");
      setDistributorId("");
      if (document?.getElementById("btn-clear-select")) {
        document.getElementById("btn-clear-select").click();
      }
    }, 10);

    await resetTableHandler();
  };

  const refreshGlobalFilter = async (e) => {
    if (isShowGlobalFilter) {
      setSearch("");
    } else {
      setAffiliateId("");

      setCompany("");
      setFirstName("");
      setLastName("");
      setEmailId("");
      setStatus("");
      setCity("");
      setState("");
      setCountry("");
      setRailId("");
    }
    setIsShowGlobalFilter(!isShowGlobalFilter);
  };

  const companyFormatter = (cell, row) => {
    return cell.toUpperCase();
  };
  const emulateHandler = (row) => {
    try {
      if (window.location) {
        const queryStr = window.location.origin;
        const url = `${frontUrl}/login?key=${row.userEmulateToken}`;
        window.open(url);
      }
    } catch (error) {
      throw error;
    }
  };

  // Add other formatter functions...
  const emulateFormatter = (cell, row) => {
    return (
      <button
        className="btn btn-primary"
        onClick={() => emulateHandler(row)}
        disabled={row.activeMember == false ? true : false}
      >
        Emulate
      </button>
    );
  };

  const emailFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.emailId}</div>}
      >
        <span style={{ whiteSpace: "nowrap" }}>
          {row.emailId.substring(0, 10)}...
          <AiOutlineCopy
            cursor={"pointer"}
            className="ms-1"
            onClick={async () => {
              if ("clipboard" in navigator) {
                await navigator.clipboard.writeText(row.emailId);
                NotificationManager.success(
                  "Copied successfully ",
                  "Success",
                  5000
                );
              }
            }}
          />
        </span>
      </Tooltip>
    );
  };
  const activeformatter = (row) => {
    return row === true ? (
      <span className="text-success"> Active</span>
    ) : (
      <span className="text-danger"> Inactive</span>
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item>
            <Link
              style={{ width: "100%", textDecoration: "none" }}
              className="btn btn-link"
              to={`/admin/merchant/edit/${row.memId}`}
            >
              <MdEdit
                className="text-primary me-4"
                size={15}
                style={{ marginLeft: "-70%" }}
              ></MdEdit>
              Edit
            </Link>
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#virtualbank"
            onClick={() => {
              virtualbankHandler(row);
            }}
          >
            <MdAccountBalanceWallet className="text-primary me-4"></MdAccountBalanceWallet>
            Virtual Bank
          </Dropdown.Item>
          <Dropdown.Item
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#service"
            onClick={() => {
              serviceMappingHandler(row);
            }}
          >
            <AiOutlineSetting className="text-primary me-4"></AiOutlineSetting>
            Service Mapping
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Reset Password `,
                html: `<form autocomplete="off"><span>Member Id - ${row.uniqueIdentity}</span><input type="hidden" id="memberId" value="${row.memId}" />
                        <input id="pwd" placeholder="New Password " class="swal2-input" type="password">
                        <input id="con-pwd" placeholder="Confirm Password " class="swal2-input" type="password"></form>`,

                showCancelButton: true,
                confirmButtonText: "Confirm",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  const data = {
                    password: document.getElementById("pwd").value,
                    memberId: document.getElementById("memberId").value,
                  };
                  let conPassword = document.getElementById("con-pwd").value;
                  if (!data.password || !conPassword) {
                    Swal.showValidationMessage(
                      `Passowrd and Confirm Password is required.`
                    );
                  } else if (data.password !== conPassword) {
                    Swal.showValidationMessage(
                      `Passowrd and Confirm Password does not match.`
                    );
                    return false;
                  } else if (data.password.length < 6) {
                    Swal.showValidationMessage("Password must be 6 characters");
                  } else {
                    const res = await resetPassword(data);
                    return res;
                  }
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      icon: "success",
                    });
                  } else {
                    Swal.fire("Error occured");
                  }
                }
              });
            }}
            href="#"
          >
            <MdVpnKey size={15} className="text-danger me-4"></MdVpnKey> Reset
            Password
          </Dropdown.Item>

          <Dropdown.Item
            href="#"
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                html: `              
              <h5 class="align-left">Name - ${row.memberFullName}</h5>
              <h5>Company Name - ${row.company}</h5>
             
              <h5>Mobile - ${row.memberMobileNo}</h5>
              <input type="text" id="memId" value=${row.memId} hidden/>
             <div class="row>
             <div class="col-12">
              <select class="form-control w-25 m-auto" id="activeStatus" > <option value="true">Activate </option> 
              <option value="false">Deactivate </option>
              </select></div></div>
              `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Update",
                cancelButtonText: "No",
                preConfirm: async () => {
                  const data = {
                    activeStatus: document.getElementById("activeStatus").value,
                    memId: document.getElementById("memId").value,
                  };

                  if (data.activeStatus) {
                    const res = await StatusUpdateHandler(data);
                    return res;
                  } else {
                  }
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      icon: "success",
                      showConfirmButton: false,
                      timer: 2500,
                    });
                    loadMember();
                  } else {
                    Swal.fire({
                      title: "Cancelled!",
                      text: "Permission denied.",
                      type: "error",
                      icon: "error",
                      timer: 1500,
                    });
                  }
                }
              });
            }}
          >
            <AiOutlineSetting
              className="text-primary me-4"
              size={15}
            ></AiOutlineSetting>
            Update Status
          </Dropdown.Item>
          {/* <Dropdown.Item
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#UpdateUserName"
            onClick={() => {
              updateUserName(row);
            }}
          >
            <AiOutlineSetting className="text-primary me-4"></AiOutlineSetting>
            Update Username{" "}
          </Dropdown.Item> */}
        </DropdownButton>
      </>
    );
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: dataCount > 0,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const dateFormatter = (cell, row) => {
    return (
      <>
        <div className="text-center">
          {moment(row.joiningDate).format("DD-MM-YYYY")}
        </div>
        <div className="text-center">
          {moment(row.joiningDate).format("hh:mm a")}
        </div>
      </>
    );
  };
  const documentFormatter = (cell, row) => {
    return (
      <>
        {row?.panFileName && (
          <div>
            <span style={{ fontWeight: "bold" }}>Pan Card Holder Name.:</span>{" "}
            {row?.panFileName}
          </div>
        )}
        <div>
          <span style={{ fontWeight: "bold" }}>Pan No.:</span> {row.panNo}
        </div>
      </>
    );
  };
  const columns = [
    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "activeMember",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: activeformatter,
    },
    {
      dataField: "uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
    },
    {
      dataField: "company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return {
          width: "200px",
          textAlign: "center",
        };
      },

      formatter: companyFormatter,
    },

    {
      dataField: "memberFullName",
      text: "Member Name",
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },

    {
      dataField: "emailId",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: emailFormatter,
    },
    // {
    //   dataField: "panNo",
    //   text: "Pan No",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "120px", textAlign: "center" };
    //   },
    // },
    {
      dataField: "id",
      text: "Document Id",
      headerStyle: () => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: documentFormatter,
    },
    {
      dataField: "memberMobileNo",
      text: "Mobile No.",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "joiningDate",
      text: "Joining Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "balance",
      text: "Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "creditLimit",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: creditBalanceFormatter,
    },
    {
      dataField: "creditLimit",
      text: "Ledger Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: ledgerBalanceFormatter,
    },
    {
      dataField: "blockedBalance",
      text: "Limit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "securityBalance",
      text: "Security Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: securityFormatter,
    },
  ];
  const context = useContext(AppContext);
  const newColumn = enableEmulate
    ? context.user.role == "Operation"
      ? [...columns]
      : [
          {
            dataField: "userEmulateToken",
            text: "Emulate",
            headerStyle: (colum, colIndex) => {
              return {
                width: "100px",
                textAlign: "center",
              };
            },

            formatter: emulateFormatter,
          },
          ...columns,
        ]
    : columns;

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const expandRow = {
    onlyOneExpanding: true,
    parentClassName: "bg-light",
    renderer: (row) => (
      <>
        <div className="d-flex m-0 b-row">
          <div className="card me-2 ">
            <div className="card-header text-center">Company Information</div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/company-image.png" alt="" />
              </div>
              <div className="col-9">
                <p className="font-weight-bold m-0">
                  ({row.uniqueIdentity ? row.uniqueIdentity?.toUpperCase() : ""}
                  ) {row.company ? row.company?.toUpperCase() : ""}
                  {row.activeMember ? "(Active)" : "(InActive)"}
                </p>
                {row.websiteName ? `Website:${row.websiteName}` : ""}

                <p className="m-0">
                  {row.companyAddress ? row.companyAddress : ""}{" "}
                  {row.stateId ? (row.stateId = "1" ? "WB," : ",") : ""}{" "}
                  {row.countryId ? (row.countryId = "1" ? "IN," : ",") : ""}{" "}
                  {row.pin ? `Pin No:${row.pin}` : ""}
                </p>
                {row.panNo ? <p className="m-0"> PAN NO.: {row.panNo} </p> : ""}
                {row.companyType ? (
                  <p className="m-0"> Type: {row.companyType}</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="card me-2">
            <div className="card-header text-center">
              Contact Person Information
            </div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/Contact-person.png" alt="" />
              </div>
              <div className="col-9">
                <p className="card-text font-weight-bold">
                  {row?.memberFirstName?.toUpperCase()}
                  {row?.memberLastName?.toUpperCase()}
                </p>

                <p className="card-text">{row.emailId}</p>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header text-center">Balance Information</div>
            <div className="card-body row">
              <div className="col-3">
                <img src="/assets/images/money-wallet.png" alt="" />
              </div>
              <div className="col-9">
                <p className="card-text font-weight-bold">
                  Balance: {parseFloat(row.balance).toFixed(2)} INR
                </p>

                <p className="card-text">
                  Limit: {parseFloat(row.creditLimit).toFixed(2)} INR{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <></>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <i style={{ cursor: "pointer" }} className="i-Arrow-Down-2"></i>;
      }
      return <i style={{ cursor: "pointer" }} className="i-Arrow-Right-2"></i>;
    },
  };
  const test = async () => {
    const response = await getMerchant();
    const totalCreditLimit = response.data.data.reduce((total, member) => {
      return total + (member.creditLimit || 0);
    }, 0);
    // console.log(totalCreditLimit);
  };
  const loadMember = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      search,
      affiliateId,

      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,

      railId,
      DistributorId,
    });

    const response = await getMerchant(query);

    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const exportMember = async () => {
    const query = queryString.getQueryStringFromObj({
      search,
      affiliateId,

      company,
      firstName,
      lastName,
      emailId,
      status,
      city,
      state,
      country,
      railId,
      DistributorId,
      memberType: "Merchant",
    });

    const response = await exportMerchant(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_merchant.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  useEffect(() => {
    loadMember();
    test();
  }, [
    page,
    sizePerPage,
    searchTrigger,
    search,
    // isShowGlobalFilter,
    // affiliateId,

    // company,
    // firstName,
    // lastName,
    // emailId,
    // status,
    // city,
    // state,
    // country,
    // group,
    // DistributorId,
  ]);

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    setSearchTrigger(!searchTrigger);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await exportMember();
    }, 10);
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [emails, setEmails] = useState([
    "test@gmail.com",
    "tesing123@zoho.com",
    "abc@gmail.com",
  ]);
  const [newEmail, setNewEmail] = useState("");

  const addEmail = () => {
    if (newEmail.trim() && !emails.includes(newEmail)) {
      setEmails([...emails, newEmail]);
      setNewEmail("");
    }
  };

  const removeEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };
  return (
    <>
      <Button
        className="btn-md float-end"
        variant="primary"
        onClick={handleShow}
      >
        <MdAddBox size={20} /> Create Group
      </Button>
      <Helmet>
        <title>B2B Group</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "B2B Group" }]}></Breadcrumb>

      <Row className="mb-2">
        <Col
          className={
            isShowGlobalFilter ? "col-12 col-md-10 mt-1" : "col-md-10 mt-1"
          }
        >
          <Form.Select aria-label="Default select example">
            <option value="1">GROUP A</option>
            <option value="2">GROUP B</option>
            <option value="3">GROUP c</option>
          </Form.Select>
        </Col>

        <Col
          className={
            isShowGlobalFilter
              ? "col-md-2 d-flex justify-content-center mt-1"
              : "col-md-2 d-flex justify-content-center mt-1"
          }
        >
          <Button
            variant="primary"
            className="mx-2 "
            onClick={refreshGlobalFilter}
          >
            {isShowGlobalFilter ? (
              <>
                Filter
                <i className="i-Filter-2  mt-1" size={15}></i>{" "}
              </>
            ) : (
              <>
                {" "}
                <i className="i-Filter-2  mt-1" size={15}></i>
              </>
            )}
          </Button>
          <Button
            variant="primary"
            //  className={"ms-4"}
            onClick={handleExport}
            disabled={!dataCount}
          >
            {isShowGlobalFilter ? (
              <>
                Export
                <AiFillFileExcel size={15} />
              </>
            ) : (
              <>
                <AiFillFileExcel size={15} />
              </>
            )}
          </Button>
        </Col>
      </Row>
      <div
        className={isShowGlobalFilter ? "collapse" : "show"}
        id="collapseExample"
      >
        <div className="card card-body rounded border mb-1">
          <div className="row">
            <div className="col-md-2 col-12 mb-1">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <MdVpnKey />
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="affiliateId"
                  placeholder="AffiliateId"
                  value={affiliateId}
                  // defaultValue={this.state.affiliateId}
                  name="affiliateId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>

            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Conference"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="CompanyName"
                  placeholder="Company Name"
                  value={company}
                  name="company"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  placeholder="First Name"
                  value={firstName}
                  name="firstName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  placeholder="Last Name"
                  value={lastName}
                  name="lastName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  @
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="emailId"
                  placeholder="Email ID"
                  value={state.emailId}
                  name="emailId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2 ">
              <select
                className="form-control mb-3"
                value={status}
                name="status"
                onChange={handleSearchChanges}
              >
                <option value=""> Select Satus</option>

                <option value="true"> Active</option>
                <option value="false"> InActive</option>
              </select>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="railId"
                  placeholder="Pan No."
                  value={railId}
                  name="railId"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            {/* <div className="col-12 col-md-4 mb-3"></div> */}

            <div className="col-12 col-md-10 d-flex justify-content-end mb-3">
              <button
                className="btn btn-outline-primary me-3"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={refreshFilter}
              >
                <MdRefresh className="mx-2" size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={
              canEdit ? newColumn : newColumn.filter((x) => x.text !== "Action")
            }
            pagination={dataCount > 0 && paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            expandRow={expandRow}
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>

      <Modal show={show} onHide={handleClose} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Create Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Form>
            <Form.Group className="mb-4" controlId="groupName">
              <Form.Label>Group Name</Form.Label>
              <Form.Control type="text" placeholder="Enter group name" />
            </Form.Group>

            <Form.Group className="mb-4" controlId="emailInput">
              <Form.Label>Add Email</Form.Label>
              <InputGroup>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                />
                <Button variant="primary" onClick={addEmail}>
                  Add
                </Button>
              </InputGroup>
            </Form.Group>

            <div
              className="border p-3 mb-4"
              style={{ height: "200px", overflowY: "auto" }}
            >
              <ListGroup variant="flush">
                {emails.map((email, index) => (
                  <ListGroup.Item
                    key={index}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div>{email}</div>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removeEmail(index)}
                    >
                      X
                    </Button>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GroupTagging;
